import { NfcReaderService } from "@softline/application";
import { BrowserNfcReaderService } from "./browser-nfc-reader.service";

export const browserNfcReaderProviders = [
  {provide: NfcReaderService, useClass: BrowserNfcReaderService}
]
